import { render, staticRenderFns } from "./flipController.vue?vue&type=template&id=1363b676&"
import script from "./flipController.vue?vue&type=script&lang=ts&"
export * from "./flipController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports